import * as React from 'react';

import {LockIcon, SiteGlobeIcon, CirclePersonIcon, ButtonIcon} from 'shells/icon';

import {Button} from '../../button/button';

import type {ButtonSize} from '../types';

type Props = {
    size?: ButtonSize;
    variant?: 'primary' | 'secondary';
    onClick?: (e: React.ChangeEvent<any>) => Promise<any> | undefined;
    shareType: 'nobody' | 'individuals' | 'everyone';
    tooltipText?: string;
};

export function ShareButton(props: Props) {
    const {shareType, ...restProps} = props;

    const getIconComponent = () => {
        switch (shareType) {
            case 'individuals':
                return CirclePersonIcon;
            case 'everyone':
                return SiteGlobeIcon;
            case 'nobody':
            default:
                return LockIcon;
        }
    };

    return (
        <Button {...restProps}>
            <div className='flex align-center'>
                <ButtonIcon size={props.size} variant={props.variant} icon={getIconComponent()} />
                Share
            </div>
        </Button>
    );
}
